import React, { useEffect, useState } from 'react';
import cs from "./style.module.css";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

const Insert = () => {
  const location = useLocation();
const [inputs, setInputs] = useState({});
const [tbsName, setTbsName] = useState('');
const [input1, setInput1] = useState('');
const [input2, setInput2] = useState('');
const [result, setResult] = useState('');
const API_URL = 'https://accessi.sgsmails.com/api.php';
const navigate = useNavigate();

const handleChange = (event) => {
const { name, value } = event.target;
setInputs({ ...inputs, [name]: value });

};


const handleInput1Change = (e) => {
  setInput1(e.target.value);
  calculateResult(e.target.value, input2);
  };
  
  const handleInput2Change = (e) => {
  setInput2(e.target.value);
  calculateResult(input1, e.target.value);
  };
  
  const calculateResult = (value1, value2) => {
  const num1 = parseFloat(value1);
  const num2 = parseFloat(value2);
  
  if (!isNaN(num1) && !isNaN(num2)) {
  setResult(num1 - num2);
  } else {
  setResult('');
  }
  };

const tableName = location.pathname.split('/')[2];

useEffect(() => {
  setTbsName(tableName);
}, [tableName]);

const handleSubmit = async (event) => {
  event.preventDefault();
  
  try {
// Construct the data object with inputs, input1, input2, and result
const dataToSend = {
...inputs,
recordD: input1,
uEmail: input2,
fr: result,
table: tableName
};

const response = await axios.post(`${API_URL}`, dataToSend);
  if (response.data.id) {
  toast.success(`Data inserted successfully into ${tableName} table`);
  navigate('/')
  } else {
  toast.error('Error inserting data.');
  }
  } catch (error) {
  console.error('Error inserting data:', error);
  toast.error('Error inserting data.');
  }
  };
  return (
    <div className={`w-full h-auto flex justify-center items-center flex-col p-6 ${cs.bgMain}`}>
      <form action="" onSubmit={handleSubmit} className='md:w-[500px] w-full h-auto p-8 rounded-md bg-white backdrop-filter backdrop-blur-sm bg-opacity-60'>
        <h1 className='text-3xl font-bold capitalize'>Fill new {tbsName} data</h1>
        <hr className='w-full h-[2px] bg-gray-500 mt-4' />
        <div className='w-full h-auto'>
            <div className='w-full h-auto flex justify-start items-center flex-col mt-4'>
              <label htmlFor="fileName" className='text-start w-full text-sm'>File Name</label>
              <input type="text" name='fileName' id='fileName' placeholder='File Name' onChange={handleChange} className='w-full h-auto py-1 px-2 outline-none mt-2'/>
            </div>
            <div className='w-full h-auto flex justify-between flex-wrap items-center mt-4'>
                <div className='md:w-[45%] h-auto w-full flex flex-col'>
                    <label htmlFor="ptype" className='text-left w-full text-sm'>Project Type</label>
                    <input type="text" name='ptype' id='ptype' placeholder='Project Type' onChange={handleChange} className='w-full h-auto py-1 px-2 outline-none mt-2'/>
                </div>
                <div className='md:w-[45%] h-auto w-full flex flex-col md:mt-0 mt-4'>
                    <label htmlFor="sample" className='text-left w-full text-sm'>Sample Provided</label>
                    <select name="sample" defaultValue={'DEFAULT'} id="sample" onChange={handleChange} className='w-full h-auto py-1 px-2 outline-none mt-2'>
                        <option value="DEFAULT" disabled>Select</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>
                </div>
            </div>
            <div className='w-full h-auto flex justify-between flex-wrap items-center mt-4'>
                <div className='md:w-[45%] h-auto w-full flex flex-col'>
                <label htmlFor="eta" className='text-left w-full text-sm'>ETA</label>
                 <input type="text" name='eta' id='eta' placeholder='ETA'  onChange={handleChange} className='w-full h-auto py-1 px-2 outline-none mt-2'/>
                </div>
                <div className='md:w-[45%] h-auto w-full flex flex-col md:mt-0 mt-4'>
                    <label htmlFor="bill" className='text-left w-full text-sm'>Billed Yet</label>
                    <select name="bill" defaultValue={'DEFAULT'} id="bill" onChange={handleChange} className='w-full h-auto py-1 px-2 outline-none mt-2'>
                        <option value="DEFAULT" disabled>Select</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>
                </div>
            </div>
            <div className='w-full h-auto flex justify-between flex-wrap items-center mt-4'>
                <div className='md:w-[45%] h-auto w-full flex flex-col'>
                    <label htmlFor="do" className='text-left w-full text-sm'>Date Ordered</label>
                    <input type="date" name='do' id='do' placeholder='Date Ordered' onChange={handleChange}  className='w-full h-auto py-1 px-2 outline-none mt-2'/>
                </div>
                <div className='md:w-[45%] h-auto w-full flex flex-col md:mt-0 mt-4'>
                <label htmlFor="dd" className='text-left w-full text-sm'>Date Delivered</label>
                    <input type="date" name='dd' id='dd' placeholder='Delivery Date' onChange={handleChange}  className='w-full h-auto py-1 px-2 outline-none mt-2'/>
                </div>
            </div>
            <div className='w-full h-auto flex justify-start items-center flex-col mt-4'>
            <label htmlFor="recordD" className='text-left w-full text-sm'>No. of Records Delivered</label>
            <input type="text" name='recordD' id='recordD' placeholder='No. of Records Delivered'  value={input1} onChange={handleInput1Change} className='w-full h-auto py-1 px-2 outline-none mt-2'/>
            </div>
            <div className='w-full h-auto flex justify-start items-center flex-col mt-4'>
            <label htmlFor="uEmail" className='text-left w-full text-sm'>No. of unacceptable emails</label>
            <input type="text" name='uEmail' id='uEmail' placeholder='No. of unacceptable emails' value={input2} onChange={handleInput2Change} className='w-full h-auto py-1 px-2 outline-none mt-2'/>
            </div>
            <div className='w-full h-auto flex justify-start items-center flex-col mt-4'>
            <label htmlFor="fr" className='text-left w-full text-sm'>Final No. of Records</label>
            <input type="text" name='fr' id='fr' placeholder='Final No. of Records' value={result} readOnly className='w-full h-auto py-1 px-2 outline-none mt-2'/>
                        
            </div>
            
            <button type='submit' className='w-full bg-green-600 text-white rounded-sm py-1 mt-4 hover:bg-green-800'>SUBMIT</button>
        </div>
      </form>
      <div className='w-full h-auto my-6'>
        <h1>View All Inserted Data!! <Link className='text-blue-600 underline' to={'/'} >View</Link></h1>
      </div>
      <ToastContainer />
    </div>
  )
}
export default Insert;
